


















































































import Vue from 'vue'
import { Location } from '@/models'
import ChatWebsiteUrlModal from './ChatWebsiteUrlModal.vue'
import { trackGaEvent } from '@/util/helper'
import ChatWidgetIcon from '@/assets/pmd/img/launchpad/icon-chat-widget-integration.svg'
export default Vue.extend({
  props: [
    'currentLocationId',
    'userid',
    'name',
    'website',
    'chatWidgetChecking',
    'isChatWidgetConnected',
    'reconnect',
  ],
  components: {
    ChatWidgetIcon,
    ChatWebsiteUrlModal,
  },
  data() {
    return {
      showModal: false,
    }
  },
  mounted() {
    this.$root.$on('close-modal', () => {
      this.showModal = false
    })
  },
  methods: {
    setupChatWidget() {
      this.showModal = true
      trackGaEvent(
        'Launchpad',
        'Initiate WebChat widget integration',
        `Webchat widget has been initiated for location: ${this.currentLocationId}`
      )
    },
  },
})
